import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { HYDRATE } from "@/redux/reducers/hydration";

export type EducationalMaterialsStoreFrontImage = {
  altText: string;
  linkUrl: string;
  sourceUrls: {
    desktop: string;
    mobile: string;
  };
};

export type EducationalMaterials = {
  storeFront: null | {
    images: EducationalMaterialsStoreFrontImage[];
  };
  licenseVerificationLink: null | {
    url: string;
    text: string;
  };
};

export type ComplianceRuleset = {
  id?: string;
  subregionCode?: string;
  regionCode?: string;
  rules?: Record<string, string | number | boolean | null> & {
    educationalMaterials?: EducationalMaterials;
  };
  created?: string;
  lastModified?: string;
};

export type ComplianceRulesState = {
  complianceRuleset: ComplianceRuleset;
};

export const initialState: ComplianceRulesState = {
  complianceRuleset: {
    regionCode: "Default",
    rules: {
      medicalDeliveryAllowed: true,
      pickupAllowed: true,
      recreationalDeliveryAllowed: true,
    },
  },
};

const complianceRulesSlice = createSlice({
  extraReducers: (builder) => {
    /**
     * Ignore any hydration events after initial page load to preserve any
     * subsequent changes that have been made on the client.
     */
    builder.addCase(HYDRATE, () => {});
  },
  initialState,
  name: "complianceRules",
  reducers: {
    loadComplianceRuleset: (
      state,
      action: PayloadAction<ComplianceRuleset>,
    ) => {
      state.complianceRuleset = action.payload;
    },
  },
});

export const { loadComplianceRuleset } = complianceRulesSlice.actions;
export default complianceRulesSlice.reducer;
